import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById('hero-cta');
    const update = () => {
      if (!target) {
        setVisible(window.scrollY > 500);
        return;
      }
      const rect = target.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <AnimatePresence data-id="element-114" data-mp="196g8ypkrq7lv">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3" data-id="element-115" data-mp="1989iqdqoh7y3">
          <div className="mx-auto w-full max-w-md" data-id="element-116" data-mp="2f3it8kxv3140">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-lime px-5 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-black shadow-[0_12px_40px_-8px_rgba(198,230,43,0.75)] sm:text-base" data-id="element-117" data-mp="21d5ossk6i4jf">
              Get it now for $27
              <ArrowRightIcon className="h-5 w-5 shrink-0" data-id="element-118" data-mp="1weuekgpz1s0o" />
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}